(function ($) {

	//Scroll magic init
	var controller = new ScrollMagic.Controller();


	// Sticky navigation

	var tablet = window.matchMedia('(min-width:767px) and (max-width: 992px)');

	var headerText = new TimelineLite();

	if (tablet.matches) { // If media query matches
		headerText.fromTo(".sub__header > h1", 2, { opacity: 0, yPercent: 200 }, { opacity: 1, yPercent: 20, ease: Power2.easeOut},  0.8);
		new ScrollMagic.Scene({triggerElement: ".sub__header"}).setTween(headerText)

			//.addIndicators()
			.offset(-450)
			.reverse(false)
			.addTo(controller);
	  } else {
		headerText.fromTo(".sub__header > h1", 2, { opacity: 0, yPercent: 100 }, { opacity: 1, yPercent: 0, ease: Power2.easeOut},  0.8);
		new ScrollMagic.Scene({triggerElement: ".sub__header"}).setTween(headerText)

			//.addIndicators()
			.offset(-450)
			.reverse(false)
			.addTo(controller);
	  }








		var isMobile = window.matchMedia("only screen and (max-width: 760px)");


	function resizePlaceholder() {
		var height = $(".o_navigation").outerHeight();
		$('.navigation__placeholder').css("height", height);
	}

	$(window).resize(function () {
		resizePlaceholder();
		if (isMobile.matches) {
			animateTabs(200);
			$(".tabsNew").css({height:$("#Nyheter").height()+200});
		}else{
			animateTabs(50);
			$(".tabsNew").css({height:$("#Nyheter").height()+200});
		}
	});



	function animateTabs($height) {
		$(".tab-label-content label").click(function(){
			$(".tabsNew").animate({height:$(this).parent().find(".tab-content").height()+$height},500);
			window.location.hash = '#'+$(this).html().toLowerCase();
		});

	}

	if(window.location.pathname == '/nyheter-och-press/' && location.hash.length > 1) {
		var hash_tag = location.hash;
		if(hash_tag.length > 0) {
			$('.tab-label-content label').each(function(i,el) {
				if('#'+$(this).html().toLowerCase() == hash_tag && hash_tag != '#videoklipp') {
					$('input[id="'+$(this).attr('for')+'"]').prop('checked',true);
					$('input[id="tab1"]').removeAttr('checked');
					var height = 50;
					if (isMobile.matches)
						height = 200;
					$(".tabsNew").animate({height:$(this).parent().find(".tab-content").height()+height},500);
				}
			});
		}
	}







	$(document).ready(function () {

		$(window).trigger('resize');
		if (isMobile.matches) {
			animateTabs(200);
			$(".tabsNew").animate({height:$("#Nyheter").height()+200},500);
		}else{
			animateTabs(300);
			$(".tabsNew").animate({height:$("#Nyheter").height()+300},500);
		}





		function setCookie(cname,cvalue,exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays*24*60*60*1000));
			var expires = "expires=" + d.toGMTString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		}

		function getCookie(cname) {
			var name = cname + "=";
			var decodedCookie = decodeURIComponent(document.cookie);
			var ca = decodedCookie.split(';');
			for(var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
			}
			return "";
		}

		function checkCookie() {
			var warningTopCookie = getCookie("warning_top");
			var warningFrontPageCookie = getCookie("warning_front");

			if (warningTopCookie != "") {
				//$(".nav__warning").remove();

			}

			if (warningFrontPageCookie != "") {
				//$(".video__warning").remove();
			}
		}

		checkCookie();

		$(".nav__warning__close").click(function (e) {
			e.preventDefault();
			$(".nav__warning").css("display", "none");

			$(".indicator").removeClass("fixed");
			resizePlaceholder();
			indicatorPosition();
			setCookie("warning_top", "warningTopCookie", 30);
		});

		$(".video__warning__close").click(function (e) {
			e.preventDefault();
			$(".video__warning").css("display", "none");
			setCookie("warning_front", "warningFrontPageCookie", 30);
		});


		$( ".e_animation" ).click(function() {
			if($(this).attr('id') === "stop"){
				$( ".spin__block" ).addClass("paused");
				$(this).attr('id', 'resume');
				$(this).html('<i class="fa fa-play"></i>');
			}
			else if($(this).attr('id') === "resume"){
				$( ".spin__block" ).removeClass("paused");
				$(this).attr('id', 'stop');
				$(this).html('<i class="fa fa-pause"></i>');
			}
		});








		////////////////////////////////////
		///// WORDPRESS ADMINBAR FIX   /////
		///////////////////////////////////////////////////////////////////////////////////////////////


		if ($("#wpadminbar").length) {
			$(".o_navigation").css("top","32px");

		}



		////////////////////////////////
		///// Chapter indicator   /////
		///////////////////////////////////////////////////////////////////////////////////////////////

		function indicatorPosition() {

			if ($('body').hasClass('page-template-default')) {
				var posFromTop = $(".indicator").offset().top;
				var navHeight = $(".o_navigation").outerHeight();


				$(window).scroll(function(){
						if($(window).scrollTop() > posFromTop - 100){
							$('.indicator').addClass('fixed');
							$('.indicator').css('top', navHeight);
						} else {
							$('.indicator').css('top', '0');
							$('.indicator').removeClass('fixed');
						}
				});
			}
		}


			indicatorPosition();





		$(window).scroll(function() {
			$('.section').each(function() {

				var scroll = $(window).scrollTop();
				var position = $(this).offset().top;

				if(scroll > position - 200){
					var id = $(this).attr('id');
					$('.indicator__item').removeClass('active');
					$('.indicator__item:nth-child('+ id +')').addClass('active');
				}
			})
		});


		var $root = $('html, body');

		$('.indicator__item>a').click(function () {
			$root.animate({
				scrollTop: $( $.attr(this, 'href') ).offset().top - 150
			}, 500);

			return false;
		});





		//////////////////////
		///// SHUTTLE   /////
		///////////////////////////////////////////////////////////////////////////////////////////////


		$(".menu-item").mouseover(function (e) {
			e.preventDefault();

			var position = $(this).position();
			var width = $(this).outerWidth();

			$(".hoverShuttle__shuttle").css({"width":width, "left":position.left, "opacity":"1"});

		});


		$(".hoverShuttle__container").mouseout(function (e) {
			e.preventDefault();

			$(".hoverShuttle__shuttle").css("opacity", "0");


		});


		//////////////////////
		///// NAVIGATION /////
		///////////////////////////////////////////////////////////////////////////////////////////////

		$(".NavAnimatedIcon").click(function (e) {
			e.preventDefault();
			$(this).siblings(".main-menu").slideToggle("fast");
			$(this).toggleClass("active");
			$(this).parent().parent().parent('.o_navigation').toggleClass("mobile");

		});


		$("i.fa-search").click(function (e) {
			e.preventDefault();
			$(this).siblings('.nav__search__container').slideToggle("fast", function() {
				if ($(this).is(':visible'))
					$(this).css('display','flex');
			});
		});



		$(".main-menu > .menu-item").mouseover(function (e) {
			e.preventDefault();

			var width = $(this).outerWidth();

			$(this).children(".sub-menu").css("minWidth",width - 2);

		});


		/////////////////////
		/// ANIMATED ICON ///
		/////////////////////////////////////////////////////////////////////////////////////////////


		$(".animatedIcon__testing").click(function () {
			$(this).toggleClass('active');

		});






		/////////////////////////////////
		///// QUESTIONS AND ANSWERS /////
		///////////////////////////////////////////////////////////////////////////////////////////////



		$(".questionsAndAnswers__title").click(function () {
			$(this).toggleClass('active');
			$(this).find(".QAanimatedIcon").toggleClass('active');
			$(this).siblings(".questionsAndAnswers__content").slideToggle("fast");
		});

		$(".questionsAndAnswers__btn__open").click(function (e) {
			e.preventDefault();
			$(".questionsAndAnswers__title").addClass('active');
			$(".questionsAndAnswers__title").find(".QAanimatedIcon").addClass('active');
			$(".questionsAndAnswers__title").siblings(".questionsAndAnswers__content").css('display', 'block');
			$(this).addClass('disabled');
			$(".questionsAndAnswers__btn__close").removeClass('disabled');
		});

		$(".questionsAndAnswers__btn__close").click(function (e) {
			e.preventDefault();
			$(".questionsAndAnswers__title").removeClass('active');
			$(".questionsAndAnswers__title").find(".QAanimatedIcon").removeClass('active');
			$(".questionsAndAnswers__title").siblings(".questionsAndAnswers__content").css('display', 'none');
			$(this).addClass('disabled');
			$(".questionsAndAnswers__btn__open").removeClass('disabled');
		});


	   	////////////////////////
		///// CONTACT FORM /////
		///////////////////////////////////////////////////////////////////////////////////////////////

		$("input:checkbox").on('click', function(){
			$(this).parent().parent().parent().siblings('.contactForm__button').toggleClass("checked");
	   });



	   	/////////////////////////
		///// COOKIECONSENT /////
		///////////////////////////////////////////////////////////////////////////////////////////////

		setTimeout(function(){
			$(".o_cookieConsent").addClass("active");
		}, 1500);

		$(".cookieConsent__button__accept").click(function (e) {
			e.preventDefault();
			$(".o_cookieConsent").removeClass("active");
			setCookie("terms_and_conditions", "accepted", 30);
		});


		/////////////////
		///// POPUP /////
		///////////////////////////////////////////////////////////////////////////////////////////////

		$(".popup__trigger").click(function (e) {
			e.preventDefault();
			$(".popup__contact__link").addClass("active");
		});

		$(".popup__icon").click(function (e) {
			e.preventDefault();
			$(".popup__contact__link").removeClass("active");
		});


		$(".popup__btn").click(function (e) {
			e.preventDefault();
			$(".popup__contact__link").removeClass("active");
		});


		//////////////////////
		///// POPUP TEAM /////
		///////////////////////////////////////////////////////////////////////////////////////////////



		$(".popup__icon__team").click(function (e) {
			e.preventDefault();
			$(this).parent().parent().removeClass("active");
			$(".indicator__wrapper").css("display","block");
		});

		  window.onclick = function(event) {
			  if (event.target == $(".o_popup.popup__team__link.active")[0] || event.target == $(".o_popup.popup__contact__link.active")[0] ) {
				  $(".o_popup").removeClass("active");
					$(".indicator__wrapper").css("display","block");
			  }
		  }

		  $(".popup__trigger__team").click(function (e) {
			e.preventDefault();
			$(this).parent().find(".popup__team__link").addClass("active");
			$(".indicator__wrapper").css("display","none");
		});

		//////////////////////
		///// REFERENCES /////
		///////////////////////////////////////////////////////////////////////////////////////////////

		$(".references__trigger").click(function (e) {
			e.preventDefault();
			$(".o_references").addClass("active");
		});

		$(".references__icon").click(function (e) {
			e.preventDefault();
			$(".o_references").removeClass("active");
		});


		$(".references__btn").click(function (e) {
			e.preventDefault();
			$(".o_references").removeClass("active");
		});


		//////////////////////
		///// TABS    /////
		///////////////////////////////////////////////////////////////////////////////////////////////


		$('.tabs__heading__container').children().each(function (index) {
			$(this).on('click', function (e) {
				var newIndex = index + 1;
				removeActiveFromTabs();
				e.preventDefault();
				$(this).addClass('active');
				$('.arrow').addClass('active' + newIndex);
				removeActiveFromArrow(newIndex);

				$('.tabs__content' + newIndex).addClass('active');


			});
		});

		function removeActiveFromTabs() {
			$('.tabs__heading__container').children().each(function () {
				$(this).removeClass('active');
			});
		}

		function removeActiveFromArrow(notIndex) {
			var listIndex = [1,2,3,4];
			listIndex.forEach(function (myNumber) {
				if (myNumber !== notIndex) {

					$('.arrow').removeClass('active' + myNumber);

					$('.tabs__content' + myNumber).removeClass('active');
				}
			});
		}

	});





	//GA track Downloads

	if ( $('.documentUploadBtn').length ) {
		$('.documentUploadBtn').click(function (e) {
			var el = $(this);
			if ( $(this)[0].text == 'Ladda ner rapporten') {
				ga('send', {
					hitType: 'event',
					eventCategory: 'File download',
					eventAction: 'click',
					eventLabel: document.title,
				});
			} else {
				ga('send', {
					hitType: 'event',
					eventCategory: 'File download',
					eventAction: 'click',
					eventLabel: $(this)[0].text,
				});
			}
		});
	}


	//GA track job clicks


	$('.job_link').click(function (e) {
		ga('send', {
			hitType: 'event',
			eventCategory: 'Job click',
			eventAction: 'click',
			eventLabel: $(this).attr('id'),
		});
	});





})(jQuery);
